import React from 'react';

import { Section } from '../types';

import SectionContent from './SectionContent';
import SectionTitle from './SectionTitle';
import LastEdited from './LastEdited';
import {
  Container,
  Separator,
  TitleContainer,
} from './ReadOnlySectionView.styled';
import ScrollBar from '../../../common/ScrollBar';
import {
  ScrollContainer,
  SectionViewContainer,
  ContentContainer,
} from '../Material.styled';

const ReadOnlySectionView = ({ section }) => (
  <Container>
    <ScrollContainer>
      <ScrollBar autoHide>
        <ContentContainer>
          <SectionViewContainer>
            <TitleContainer>
              <SectionTitle value={section.title} />
              <Separator height="16px" />
              <LastEdited
                editedAt={section.updatedAt}
                createdAt={section.createdAt}
              />
            </TitleContainer>
            <SectionContent
              content={section.content}
              sectionId={section.id}
              versionId={section.version}
            />
          </SectionViewContainer>
        </ContentContainer>
      </ScrollBar>
    </ScrollContainer>
  </Container>
);

ReadOnlySectionView.propTypes = {
  section: Section.isRequired,
};

export default ReadOnlySectionView;
